import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbMissionPlanTemplateConstParam extends IAloDbBaseConstParam {
    MPT_ID:number|null
    ENS_ID:number|null
    MPT_LIBELLE:string
    MPT_JSON:string
  }

export class AloDbMissionPlanTemplate extends AloDbBase {
        
    public MPT_ID:number|null
    public ENS_ID :number|null  
    public MPT_LIBELLE :string
    public MPT_JSON :string

    constructor({MPT_ID,ENS_ID,MPT_LIBELLE,MPT_JSON,...args }:IAloDbMissionPlanTemplateConstParam = {} as IAloDbMissionPlanTemplateConstParam) {
        super(args)
        this.MPT_ID = MPT_ID
        this.ENS_ID = ENS_ID
        this.MPT_LIBELLE = MPT_LIBELLE
        this.MPT_JSON = MPT_JSON
    }

    static createAloDbMissionPlanTemplateArray(datas:any) {
        return new AloBaseArray(AloDbMissionPlanTemplate,datas)
    }

    static createAloDbMissionPlanTemplateWithDetail(data:any) {
        return new AloDbMissionPlanTemplate({...data,detailLoaded:true})
    }
}
